var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eye-canvas"},[_c('div',{ref:"eyeNodeContainer",staticStyle:{"width":"500px","height":"400px"},attrs:{"id":"eyeNodeContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }